import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';
import { FieldMetadata, ViewMetadata } from '@data/cer-data-types';

export class VoucherPostingProjectForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet): void {
    const navProject = this.routeOptions.navigation?.columnNameChild == 'projectNum';
    const view = VoucherPostingProjectForm.viewGet(navProject);
    viewSet.viewAdd(view);
  }

  public static viewGet(navProject: boolean): CerFormView {

    const view = new CerFormView();
    view.viewMetadata = VoucherPostingProjectForm.viewMetadata;
    view.fieldMetadata = VoucherPostingProjectForm.fieldMetadata;
    if (navProject) {
      const hideCols = ['projectNum', 'projectName'];
      view.fieldMetadata.filter(f => hideCols.includes(f.name)).forEach(f => f.visible = false);
      view.fieldMetadata.filter(f => hideCols.includes(f.name)).forEach(f => f.visible = false);

      const filterCol = 'projectCostType';
      const f = view.fieldMetadata.find(f => f.name == filterCol);
      if (f) {
        // Exclude sales
        f.filterOperator = 'notequal';
        f.filterValue = '100';
        f.filterOnClient = true;
      }

    }
    return view;
  }

  // View
  public static viewMetadata: ViewMetadata = {
    name: 'project-voucher', dataApiName: 'VoucherPostingProject',
    text: 'Projekt bilag', titleFields: ['voucherNum', 'accountNum'],
    allowEdit: false, allowDelete: false, allowCreate: false,
    primaryKey: 'id', baseFields: ['id', 'history'],
    navigations: [
      { link: 'nav', title: 'Vis bilag', foreignKey: { parentEntity: 'Voucher', parentColumn: 'id', column: 'voucherId' } },
      { link: 'navMenu', foreignKey: { parentEntity: 'VendorView', parentColumn: 'num', column: 'vendorNum' } },
      { link: 'navMenu', foreignKey: { parentEntity: 'FinanceProjectTrans', parentColumn: 'projectNum', column: 'projectNum' } },
      { link: 'navMenu', foreignKey: { parentEntity: 'RefDataProduct', parentColumn: 'projectNum', column: 'projectNum' } }
    ]
  };

  public static fieldMetadata: FieldMetadata[] = [
    { name: 'id', text: "Kontering id", format: 'Integer', width: '90px', visible: false },
    { name: 'transDate', text: "Dato", format: 'DateShort', width: '100px', orderBy: 'Descending' },
    //{ name: 'documentDate', text: "Document dato", format: 'DateShort', visible: false, width: '100px' },
    { name: 'amountCost', text: "Omkostning", format: 'Amount', width: '80px' },
    { name: 'lineNum', text: "Linjenr.", format: 'Integer', width: '90px', visible: false },
    { name: 'projectNum', text: "Projekt", width: '60px', foreignKey: { navigations: [{ link: ['nav', 'fk'], title: 'Projekt', foreignKey: { parentEntity: 'RefDataProduct', parentColumn: 'projectNum' } }] } },
    { name: 'productNum', text: "ISBN", width: '120px', visible: false, },
    { name: 'projectName', text: "Navn", width: '100px' },
    { name: 'responsible', text: "Redaktør", fieldType: 'userShortName', width: '60px'},
    { name: 'approver', text: "Godkender", width: '70px', foreignKeyType: 'user' },
    { name: 'status', text: "Status", visible: false, width: '80px', foreignKeyType: 'voucherApprovalStatus' },
    { name: 'projectCostType', text: "Art", width: '80px', foreignKeyType: 'financeProjectCostType' },
    { name: 'voucherNum', text: "Bilagsnr.", width: '80px' },
    { name: 'documentNum', text: "Fakturanr.", width: '80px' },
    { name: 'projectLedgerNum', text: "Bogføring", width: '120px', fieldType: 'financeLedgerAccount' },
    { name: 'category', text: "Kategori", width: '80px', visible: false, foreignKeyType: 'voucherCategory' },
    { name: 'projectCostGroup', text: "Gruppe", width: '80px', visible: false },
    { name: 'msgId', text: "Besked id", format: 'Integer', visible: false, width: '90px' },
    { name: 'voucherId', text: "Bilag id", format: 'Integer', visible: false, width: '80px' },
    { name: 'taxCode', text: "Momskode", width: '65px', fieldType: 'financeTaxCode', visible: false },
    { name: 'department', text: "Afdeling", width: '60px', visible: false },
    { name: 'postedStatus', text: "Bogføring", width: '80px', visible: false },
    { name: 'vendorNum', fieldType: 'vendor', width: '60px', visible: true },
    { name: 'vendorName', text: 'Kreditornavn', width: '100px', visible: true, foreignKeyUsing: 'vendorNum' },
    { name: 'amountCur', text: "Beløb", format: 'Amount', width: '80px' },
    { name: 'currency', text: "Valuta", width: '40px', foreignKeyType: 'currencyId' },
    { name: 'txt', text: "Posteringstekst", width: '100px', visible: false }
  ];
}
